<template>
  <div class="home-main">
    <HomeHerder></HomeHerder>
    <div class="page1">
      <div class="title">{{ $t("module.commerce.title1") }}</div>
      <div class="content">
        <img class="content-left" src="@/assets/image/module/love.png" />

        <div class="content-right">
          <div class="right-title">{{ $t("module.commerce.title2") }}</div>
          <div class="line"></div>
          <div class="line-box">
            <div class="line-left">{{ $t("module.commerce.title3") }}</div>
            <div class="line-right line-right2">
              {{ $t("module.commerce.title4") }}
            </div>
          </div>
          <div class="line-box">
            <div class="line-left-img">
              <img src="@/assets/image/module/dui.png" />
              {{ $t("module.commerce.title5") }}
            </div>
            <div class="line-right-img line-right2">
              <img src="@/assets/image/module/emali.png" /> 1234567890@163.com
            </div>
          </div>
          <div class="line-box">
            <div class="line-left-img">
              <img src="@/assets/image/module/dui.png" />
              {{ $t("module.commerce.title6") }}
            </div>
          </div>
          <div class="line-box">
            <div class="line-left-img">
              <img src="@/assets/image/module/dui.png" />
              {{ $t("module.commerce.title7") }}
            </div>
          </div>
          <div class="line-box line-box2">
            <div class="line-left">{{ $t("module.commerce.title4") }}</div>
          </div>
          <div class="line-box line-box2">
            <div class="line-left-img2">
              <img src="@/assets/image/module/emali.png" />
              {{ $t("module.commerce.title7") }}
              1234567890@163.com
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- 页脚 -->
    <div
      class="footer-box"
      :style="`background-color:${
        this.active === '/module/exchange' ? '#FAFAFA' : '#fff'
      }`"
    >
      <div class="content-box">
        <div class="icon-box" @click="goUrl('/')">
          <img src="@/assets/image/common/logo-bule.png" />
        </div>
        <div class="line"></div>
        <div class="info-boxs">
          <div class="info-box">
            <div class="herder">{{ $t("home.footer.title3") }}</div>
            <div class="tips">
              我是内容我是内容我是内容 我是内容我是内容我是内容 我是内容我是内容
            </div>
          </div>
          <div class="info-box">
            <div class="herder">{{ $t("home.footer.title4") }}</div>

            <div class="item-box">
              <div class="item">{{ $t("home.footer.title5") }}</div>
              <div class="item">{{ $t("home.footer.title6") }}</div>
            </div>
          </div>
          <div class="info-box">
            <div class="herder">{{ $t("home.footer.title7") }}</div>
            <div class="item-box">
              <div class="item">{{ $t("home.footer.title8") }}</div>
              <div class="item">{{ $t("home.footer.title9") }}</div>
            </div>
          </div>
          <div class="info-box">
            <div class="herder">{{ $t("home.footer.title10") }}</div>
            <div class="item-box">
              <div class="item">{{ $t("home.footer.title11") }}</div>
              <div class="item">{{ $t("home.footer.title12") }}</div>
              <div class="item">{{ $t("home.footer.title13") }}</div>
            </div>
          </div>
          <div class="info-box">
            <div class="herder">
              <img src="@/assets/image/module/emali-black.png" />
              <span>1234567890@163.com</span>
            </div>
            <div class="code-box">
              <img src="@/assets/image/home/weixin.png" />
              <div>{{ $t("home.footer.title14") }}</div>
            </div>
          </div>
        </div>
      </div>

      <div class="filing">
        Copyright © 2023 All Rights Reserved.版权所有
        江北新区研科计算机系统服务中心 苏ICP备123456789号-1
      </div>
    </div>
    <!-- 页脚移动端 -->
    <div class="footer-box2">
      <div class="content-box">
        <div class="icon-box" @click="goUrl('/')">
          <img src="@/assets/image/common/logo-bule.png" />
        </div>
        <div class="line"></div>
        <div class="info-boxs">
          <div class="info-box">
            <div class="item-box">
              <div class="item">{{ $t("home.footer.title5") }}</div>
              <div class="item">{{ $t("home.footer.title8") }}</div>
              <div class="item">{{ $t("home.footer.title9") }}</div>
            </div>
          </div>
          <div class="info-box">
            <div class="item-box">
              <div class="item">{{ $t("home.footer.title13") }}</div>
              <div class="item">{{ $t("home.footer.title11") }}</div>
              <div class="item">{{ $t("home.footer.title12") }}</div>
            </div>
          </div>
          <div class="info-box">
            <div class="item-box">
              <div class="item">{{ $t("home.footer.title15") }}</div>
              <div class="herder">
                <img src="@/assets/image/module/emali-black.png" />
                <span>1234567890@163.com</span>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="filing">
        <div>Copyright © 2023 All Rights Reserved.</div>
        <div>版权所有 江北新区研科计算机系统服务中心</div>
        <div>苏ICP备123456789号-1</div>
      </div>
    </div>
  </div>
</template>
<script>
import HomeHerder from "@/components/Herder/homeHerder.vue";
export default {
  data() {
    return {
      active: "",
    };
  },
  components: {
    HomeHerder,
  },
  methods: {
    goLogin() {
      this.$router.push("/login");
    },
        goUrl(path) {
      this.$router.push(path);
    },
  },
};
</script>
<style lang="scss" scoped>
.home-main {
  width: 100%;

  .page1 {
    width: 100%;
    min-height: 735px;
    // height: 100vh;
    background-image: url("../assets/image/module/bg9.png");
    background-size: cover;
    background-position: 100% 100%;
    background-repeat: no-repeat;
    color: #fff;
    .title {
      text-align: center;
      color: #fff;
      padding-top: 157px;
      font-size: 20px;
      font-weight: bolder;
    }
    .content {
      width: 964px;
      height: 294px;
      background: #ffffff;
      box-shadow: 0px 3px 10px 1px rgba(0, 0, 0, 0.05);
      border-radius: 8px;
      position: relative;
      left: 50%;
      transform: translateX(-50%);
      top: 53px;
      display: flex;
      justify-content: center;
      .content-left {
        width: 100px;
        height: 100px;
        flex-shrink: 0;
        margin: 100px 92px 0 100px;
      }
      .content-right {
        width: 572px;
        color: #474f66;
        margin-top: 45px;
        .line {
          height: 1px;
          background-color: #e6e6e6;
          margin-top: 10px;
        }
        .line-box {
          display: flex;
          color: #474f66;
          font-size: 14px;
          margin-top: 15px;
          .line-left {
            width: 298px;
            margin-right: 76px;
          }
          .line-left-img {
            display: flex;
            align-items: center;
            width: 298px;
            height: 34px;
            background: rgba(137, 72, 255, 0.1);
            border-radius: 20px 20px 20px 20px;
            margin-right: 76px;
            img {
              width: 16px;
              height: 16px;
              margin: 0 10px;
            }
          }
          .line-right-img {
            font-size: 14px;
            display: flex;
            align-items: center;
            img {
              width: 28px;
              height: 28px;
              margin-right: 12px;
            }
          }
        }
        .line-box2{
          display: none;
        }
      }
    }
  }

  //页脚
  .footer-box {
    width: 100%;
    height: 400px;
    padding-top: 40px;
    box-sizing: border-box;
    background-color: #fff;
    .content-box {
      width: calc(100% - 280px);
      margin-left: 140px;
      .icon-box {
        width: 145px;
        height: 50px;
        margin-bottom: 31px;
        cursor: pointer;
        img {
          width: 100%;
          height: 100%;
        }
      }
      .line {
        width: 100%;
        height: 1px;
        background: #e9ecee;
      }
      .info-boxs {
        display: flex;
        margin-top: 39px;
        justify-content: space-between;
        .info-box {
          .herder {
            color: #474f66;
            font-size: 16px;
            display: flex;
            align-items: center;
            span {
              font-size: 14px;
            }
            img {
              width: 20px;
              height: 20px;
              margin-right: 10px;
            }
          }
          .tips {
            width: 200px;
            font-size: 14px;
            color: #474f66;
            margin-top: 34px;
            line-height: 30px;
          }
          .item-box {
            display: flex;
            flex-direction: column;
            margin-top: 34px;
            .item {
              margin-bottom: 24px;
              color: #474f66;
            }
            .item:last-child {
              margin-bottom: 0;
            }
          }
          .code-box {
            img {
              width: 82px;
              height: 82px;
              margin-top: 35px;
            }
            div {
              width: 82px;
              text-align: center;
              font-size: 14px;
              color: #474f66;
            }
          }
        }
      }
    }
    .filing {
      text-align: center;
      color: #474f66;
      margin-top: 40px;
      font-size: 14px;
    }
  }

  //页脚2
  .footer-box2 {
    width: 100%;
    height: 400px;
    padding-top: 40px;
    box-sizing: border-box;
    background-color: #fff;
    display: none;
    .content-box {
      width: calc(100% - 28px);
      margin-left: 14px;
      .icon-box {
        width: 101px;
        height: 34px;
        margin-bottom: 30px;
        cursor: pointer;
        img {
          width: 100%;
          height: 100%;
        }
      }
      .line {
        width: 100%;
        height: 1px;
        background: #e9ecee;
      }
      .info-boxs {
        display: flex;
        margin-top: 49px;
        flex-direction: column;
        .info-box {
          margin-bottom: 27px;
          .item-box {
            display: flex;
            justify-content: space-between;
            .item {
              color: #474f66;
            }
            .item:last-child {
              margin-bottom: 0;
            }
            .herder {
              color: #474f66;
              font-size: 16px;
              display: flex;
              align-items: center;
              span {
                font-size: 14px;
              }
              img {
                width: 20px;
                height: 20px;
                margin-right: 10px;
              }
            }
          }
        }
      }
    }
    .filing {
      text-align: center;
      font-size: 12px;
      color: #474f66;
      line-height: 20px;
      margin-top: 30px;
    }
  }
}
</style>

<style lang="scss" scoped>
/* 媒体查询 */
@media only screen and (max-width: 1300px) {
  .home-main {
    //页脚
    .footer-box {
      .content-box {
        width: calc(100% - 140px);
        margin-left: 70px;
        margin-top: 60px;
      }
    }
  }
}

/* 媒体查询 */
@media only screen and (max-width: 1200px) {
  .home-main {
    //页脚
    .footer-box {
      .content-box {
        width: calc(100% - 60px);
        margin-left: 30px;
        margin-top: 60px;
      }
    }
  }
}

/* 媒体查询 */
@media only screen and (max-width: 1000px) {
  .home-main {
    .page1 {
      min-height: 700px;
      padding: 0 15px;
      box-sizing: border-box;
      .content {
        width: 100%;
        padding: 0 15px;
        box-sizing: border-box;
        .content-left {
          display: none;
        }
        .content-right {
          width: 100%;
        }
      }
    }
    //页脚
    .footer-box {
      display: none;
      margin-top: 40px;
    }
    .footer-box2 {
      display: block;
      margin-top: 40px;
    }
  }
}

/* 媒体查询 */
@media only screen and (max-width: 750px) {
  .home-main {
    .page1 {
      min-height: 700px;
      padding: 0 15px;
      box-sizing: border-box;
      .content {
        width: 100%;
        padding: 0 15px;
        box-sizing: border-box;
        height: 375px;
        .content-left {
          display: none;
        }
        .content-right {
          width: 100%;
          .right-title {
            text-align: center;
          }
          .line-box {
            display: flex;
            justify-content: center;
            .line-left {
              margin-right: 0;
            }
            .line-left-img {
              margin-right: 0;
            }
            .line-left-img2 {
              font-size: 14px;
              display: flex;
              align-items: center;
                       width: 298px;
            height: 34px;
              img {
                width: 28px;
                height: 28px;
                margin-right: 12px;
              }
            }
            .line-right2 {
              display: none;
            }
          }
          .line-box2{
            display: flex;
          }
        }
      }
    }
  }
}
</style>